import API from "../API";
import AuthAPI from "../Client";
// import APINoSubdomain from "./APINoSubdomain";

export const updateChangePasswordAPI = (payload) => {
  return AuthAPI.put("/changepassword", payload)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      throw error;
    });
};

export const addPasswordAPI = (payload) => {
  return AuthAPI.put("/addpassword", payload)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      throw error;
    });
};

export const updateUserDetailsAPI = (payload) => {
  return AuthAPI.put("/userdetails", payload)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      throw error;
    });
};
